module.exports = __webpack_public_path__ + "media/images/common/search_btn_ov-d3a01c5123268c7d38637e29b2a6e096.png";